import { FormField, FormGrid, Text } from '@dixa/lib-shared-habla';
import { useFormContext } from 'react-hook-form';

import { HookFormText, HookFormTextarea } from 'components/hookForm';

export const ChatbotCreation = (): JSX.Element => {
  const { control } = useFormContext();
  return (
    <FormGrid>
      <FormField>
        <Text.Paragraph as="span">
          Please enter your API key and token. You can find them in{' '}
          <a
            href="https://app.elev.io/apikeys"
            target="_blank"
            rel="noreferrer"
          >
            https://app.elev.io/apikeys
          </a>
        </Text.Paragraph>
      </FormField>

      <FormField>
        <HookFormText
          name="apiKey"
          label="API Key"
          control={control}
          rules={{
            required: 'API Key is required',
          }}
        />
      </FormField>

      <FormField>
        <HookFormTextarea
          name="token"
          label="API Token"
          control={control}
          rules={{
            required: 'API Token is required',
          }}
        />
      </FormField>
    </FormGrid>
  );
};
